<script setup lang="ts">
const props = defineProps({
	date: {
		type: String,
		default: '',
	},
	timezone: {
		type: String,
		default: '',
	},
});
const { isMobile } = useWindowResize();

const month = computed(() => {
	return props.date ? convertDateTimeFromUtcToTimezone(props.date, props.timezone, 'MMM') : '-';
});

const day = computed(() => {
	return props.date ? convertDateTimeFromUtcToTimezone(props.date, props.timezone, 'DD') : '-';
});
</script>
<template>
  <div class="calendar">
    <div class="month text-xs text-semibold">
      {{ month }}
    </div>
    <div :class="['day', 'text-regular', isMobile ? 'text-display-xs' : 'text-display-md']">
      {{ day }}
    </div>
  </div>
</template>
<style scoped lang="scss">
.calendar {
    display: flex;
    flex-direction: column;
    overflow: hidden;
    min-width: rem(77);
    text-align: center;
    @include border-radius-default;

    > div {
        padding: spacings-get(1) spacings-get(4);
        box-sizing: border-box;
    }

    .month {
        min-height: rem(26);
        color: colors-get(gray, 800);
        text-transform: uppercase;
        background: colors-get(gray, 200);
    }

    .day {
        display: flex;
        justify-content: center;
        align-items: center;
        min-height: rem(52);
        color: colors-get(base, black);
        background: colors-get(gray, 50);
        border-bottom-left-radius: border-radius-get(default);
        border-bottom-right-radius: border-radius-get(default);

        @include media-query-max(mobile) {
          min-height: rem(40);
          @include fonts-size()
        }
    }
}
</style>

